/**
 * Labstep
 *
 * @module components/OrderRequest/Action/Create
 * @desc Create Action for order request workflow
 */

import { OrderRequestActionCreateWizardTrigger } from 'labstep-web/components/OrderRequest/Action/Create/Wizard/Trigger';
import type React from 'react';
import type { OrderRequestActionCreateProps } from './types';
export const OrderRequestActionCreate: React.FC<
  OrderRequestActionCreateProps
> = ({ resource, purchaseOrder, actionComponentProps }) => {
  return (
    <OrderRequestActionCreateWizardTrigger
      actionComponentProps={actionComponentProps}
      resource={resource}
      purchaseOrder={purchaseOrder}
    />
  );
};
